export default __webpack_public_path__ + "static/media/miscellaneous.bd21f0f3.svg";